import '../../../../../styles/globals.css'
import { Box, Typography } from '@mui/material'
import { Grid } from '@mui/material';

import UsernameIconDisplay from '../UsernameIconDisplay';
import GetYoutubeCode from '../NoteUtils';
import LoveSectionComponent from '../LoveSectionComponent';
import NoteExpiryGridPiece from '../NoteExpiryGridPiece';
import DeleteNoteSectionComponent from '../DeleteNoteSectionComponent';
import YouTubePlayer from '../../../../media/YoutubePlayer';

function YoutubeNoteComponent(props) {

    return (
        <Box>
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
                <Grid container className='' spacing={0.5} sx={{
                    maxWidth: "21.55rem",
                    minWidth: "21.55rem",
                    width: "100.0%",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "0.5rem",
                    margin: "0.25rem",
                    backgroundColor: "rgba(221, 221, 221, 0.075)",
                    borderRadius: "0.25rem",
                    borderColor: "rgba(221, 221, 221, 0.25)",
                    border: "1px solid rgba(221, 221, 221, 0.35)"
                }}>
                    <Grid item xs={6} sm={6}>
                        <UsernameIconDisplay note={props.note} />
                    </Grid>
                    <DeleteNoteSectionComponent note={props.note} />
                    <LoveSectionComponent note={props.note} />
                    <Grid item xs={12} sm={12} sx={{ width: "100%", marginTop: "0.45rem", marginBottom: "0.5rem", justifyContent: "center", alignItems: "center", marginRight: "0.1rem" }}>
                        <Typography variant="body2" component="div" gutterBottom sx={{ marginBottom: "0.625rem" }}>
                            {props.note.isNewsletterNote ? props.note.text : "is currently feeling.."}
                            <Box sx={{ marginTop: "0.325rem" }} />
                            {/*
                            {props.moodTags.map((moodTag) => {
                                return (
                                    <strong>#{moodTag.hashTag} </strong>
                                );
                            })} */}
                        </Typography>
                        <Box sx={{
                            width: "100%", display: "flex", justifyContent: "center", alignItems: "center"
                        }}>
                            <Box sx={{
                                width: "18.9325rem", height: "9.55rem",
                                marginTop: "0.325rem",
                                backgroundColor: "rgba(221, 221, 221, 0.075)",
                                borderRadius: "0.25rem",
                                borderColor: "rgba(221, 221, 221, 0.25)",
                                border: "1px solid rgba(221, 221, 221, 0.35)"
                            }}>
                                <YouTubePlayer videoId={GetYoutubeCode(props.note.url)} ></YouTubePlayer>
                                {/*<iframe src={"https://www.youtube.com/embed/" + GetYoutubeCode(props.note.url)} title="Featured video" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen;" allowfullscreen></iframe>
                                */}
                            </Box>
                        </Box>
                    </Grid>
                    <NoteExpiryGridPiece note={props.note} neverExpires={props.neverExpires} />
                    <Grid item xs={6} sm={6} sx={{ textAlign: "right", paddingRight: "1rem", padding: "0.5rem" }}>
                        <Typography variant="body2" component="div" gutterBottom sx={{ marginBottom: "0.0rem" }}>
                            {
                                props.hideGenre || true ? <div /> :
                                    <Typography variant="body2" component="div" gutterBottom sx={{ marginBottom: "0.0rem" }}>
                                        genre: <strong>#alt-pop</strong>
                                    </Typography>
                            }
                        </Typography>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
}

export default YoutubeNoteComponent;